// Define an enum with string literal values
enum scheduleTypeEnum {
  EveryWeek = "every_week",
  EveryOneWeek = "every_one_weeks",
  EveryTwoWeeks = "every_two_weeks",
  EveryThreeWeeks = "every_three_weeks",
  EveryFourWeeks = "every_four_weeks",
  Custom = "custom",
}

// Create a constant array to define the scheduleTypeType
const scheduleType: { value: string; label: string }[] = [
  // { value: scheduleTypeEnum.EveryWeek, label: "Every Week" },
  { value: scheduleTypeEnum.EveryOneWeek, label: "One Week" },
  { value: scheduleTypeEnum.EveryTwoWeeks, label: "Two Weeks" },
  { value: scheduleTypeEnum.EveryThreeWeeks, label: "Three Weeks" },
  { value: scheduleTypeEnum.EveryFourWeeks, label: "Four  Weeks" },
  { value: scheduleTypeEnum.Custom, label: "Custom" },
];

export { scheduleTypeEnum, scheduleType };
